<template>
  <div class="display-flex align-items-center justify-content-center container-logo">
    <div>
      <div class="center-mobile">
        <div class="content-logo">
          <img
            src="@/assets/images/loz-takoz-urban-taqueria-logo.png"
            alt="Loz Takoz - An Urban Taqueria - Mexican Street Food Logo"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BannerLayout",
  data() {
    return {
      //variables
    };
  },
};
</script>

<style scoped>
.green {
  color: #c9da2b;
}

.pink {
  color: #dd4999;
}

.txt-title {
  color: #c9da2b;
  font-size: 25px;
  text-align: center;
  text-transform: uppercase;
}

.container-logo {
  background-color: transparent;
  width: 100%;
  height: 100%;
  z-index: 1;
  position: relative;
}

.center-mobile {
  display: flex;
  align-items: center;
  justify-content: center;
}

.content-logo {
  width: 65vw;
  max-width: 850px;
}

.content-logo img {
  width: 100%;
  height: auto;
  border-radius: 8px;
}

@media (max-width: 600px) {
  .content-logo {
    width: 90vw;
  }
}
</style>